/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_HintInputs */

const cs_deal_splits_hint = /** @type {(inputs: Deal_Splits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podíl jednotlivých makléřů na provizi z tohoto obchodu.`)
};

const en_deal_splits_hint = /** @type {(inputs: Deal_Splits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per-agent share of the agency commission on this deal.`)
};

/**
* | output |
* | --- |
* | "Per-agent share of the agency commission on this deal." |
*
* @param {Deal_Splits_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_hint = /** @type {((inputs?: Deal_Splits_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_hint(inputs)
	return cs_deal_splits_hint(inputs)
});